export default __webpack_public_path__ + "media/images/background-cybre-light-9f693fc4a8008dd59015c413330d92d6.png";